export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15165.6b3d8874.jpg";